import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import NoBallBatRunsPopupDetails from './NoBallBatRunsPopupDetails.vue'

export const NoBallBatRunsPopup = new PopupBuilder(
  'Number of No ball + bat Runs',
)
  .appendBody(NoBallBatRunsPopupDetails)
  .build()
